module.exports = __webpack_public_path__ + "static/dumpster-rental-banner-a9f81e15be0ae9c3a22bb8e89edc1724.jpg";